var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-item',{staticClass:"sensitive",attrs:{"label":_vm.data.fieldname}},[_c('span',{staticClass:"fs-warning"},[_vm._v(_vm._s(_vm.$t('message["345"]')))])])}
var staticRenderFns = []

export { render, staticRenderFns }